export var LinkVariant;
(function (LinkVariant) {
    LinkVariant["Brand"] = "brand";
    LinkVariant["BrandQuiet"] = "brand_quiet";
    LinkVariant["Grey"] = "grey";
    LinkVariant["GreyQuiet"] = "grey_quiet";
    LinkVariant["BrandCancel"] = "brand_cancel";
    LinkVariant["Club"] = "club";
})(LinkVariant || (LinkVariant = {}));
